import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { ActionThankYouComponent } from './jobs/action-thank-you/action-thank-you.component';
import { ApplicantMessageResolver } from './jobs/applicant-message/applicant-message-resolver.service';
import { ApplicantMessageComponent } from './jobs/applicant-message/applicant-message.component';
import { ApplyEducationHistoryResolver } from './jobs/apply-education-history/apply-education-history-resolver.service';
import { ApplyEducationHistoryComponent } from './jobs/apply-education-history/apply-education-history.component';
import { ApplyEmploymentHistoryResolver } from './jobs/apply-employment-history/apply-employment-history-resolver.service';
import { ApplyEmploymentHistoryComponent } from './jobs/apply-employment-history/apply-employment-history.component';
import { ApplyPersonalInformationResolver } from './jobs/apply-personal-information/apply-personal-information-resolver.service';
import { ApplyPersonalInformationComponent } from './jobs/apply-personal-information/apply-personal-information.component';
import { ApplyReferenceResolver } from './jobs/apply-reference/apply-reference-resolver.service';
import { ApplyReferenceComponent } from './jobs/apply-reference/apply-reference.component';
import { ApplyResumeResolver } from './jobs/apply-resume/apply-resume-resolver.service';
import { ApplyResumeComponent } from './jobs/apply-resume/apply-resume.component';
import { ApplySurveyResolver } from './jobs/apply-survey/apply-survey-resolver.service';
import { ApplySurveyComponent } from './jobs/apply-survey/apply-survey.component';
import {
  ApplyVoluntaryIdentificationResolver
} from './jobs/apply-voluntary-identification/apply-voluntary-identification-resolver.service';
import { ApplyVoluntaryIdentificationComponent } from './jobs/apply-voluntary-identification/apply-voluntary-identification.component';
import { ContinueSavedApplicationResolverService } from './jobs/continue-saved-application/continue-saved-application-resolver.service';
import { ContinueSavedApplicationComponent } from './jobs/continue-saved-application/continue-saved-application.component';
import { DirectJobLinkResolverService } from './jobs/direct-job-link/direct-job-link-resolver.service';
import { DirectJobLinkComponent } from './jobs/direct-job-link/direct-job-link.component';
import { IterativeApplicationLandingResolver } from './jobs/iterative-application-landing/iterative-application-landing-resolver.service';
import { IterativeApplicationLandingComponent } from './jobs/iterative-application-landing/iterative-application-landing.component';
import { PartOneCompletionResolver } from './jobs/iterative-application-landing/part-one-completion-resolver.service';
import { JobClosedComponent } from './jobs/job-closed/job-closed.component';
import { JobStatusResolver } from './jobs/job-status-resolver.service';
import { JobNotFoundComponent } from './jobs/job/job-not-found/job-not-found.component';
import { JobResolver } from './jobs/job/job-resolver.service';
import { JobComponent } from './jobs/job/job.component';
import { JobsResolver } from './jobs/jobs-resolver.service';
import { JobsComponent } from './jobs/jobs.component';
import { OfferResolver } from './jobs/offer/offer-resolver.service';
import { OfferComponent } from './jobs/offer/offer.component';
import { ReviewAndSubmitResolver } from './jobs/review-and-submit/review-and-submit-resolver.service';
import { ReviewAndSubmitComponent } from './jobs/review-and-submit/review-and-submit.component';
import { ScheduleResolver } from './jobs/schedule/schedule-resolver.service';
import { ScheduleComponent } from './jobs/schedule/schedule.component';
import {
  SubmitIterativeApplicationPartComponent
} from './jobs/submit-iterative-application-part/submit-iterative-application-part.component';
import { SubmitReferenceResolver } from './jobs/submit-reference/submit-reference-resolver.service';
import { SubmitReferenceComponent } from './jobs/submit-reference/submit-reference.component';
import { ApplicantFileLayoutComponent } from './layouts/applicant-file-layout/applicant-file-layout.component';
import { ApplicationLayoutComponent } from './layouts/application-layout/application-layout.component';
import { ThemeResolver } from './layouts/theme-resolver.service';
import { ShellResolver } from './shell/shell-resolver.service';
import { ShellComponent } from './shell/shell.component';

const jobRoutes: Routes = [
  {
    path: '',
    resolve: { model: ThemeResolver },
    children: [
      {
        path: '',
        component: JobsComponent,
        resolve: { model: JobsResolver },
      }
    ]
  },
  {
    path: 'jobs/job-not-found',
    component: JobNotFoundComponent,
    resolve: { model: ThemeResolver }
  },
  {
    path: 'jobs/:jobId',
    component: ApplicantFileLayoutComponent,
    resolve: { model: ThemeResolver },
    children: [
      {
        path: '',
        component: JobComponent,
        resolve: { status: JobStatusResolver, model: JobResolver }
      },
      {
        path: 'continue-saved-application',
        component: ContinueSavedApplicationComponent,
        resolve: { model: ContinueSavedApplicationResolverService }
      },
      {
        path: ':slug',
        component: JobComponent,
        resolve: { status: JobStatusResolver, model: JobResolver }
      },
    ]
  },
  {
    path: 'jobs/:jobId/apply/:applicantId',
    component: ApplicationLayoutComponent,
    resolve: { model: ThemeResolver },
    children: [
      {
        path: 'resume',
        component: ApplyResumeComponent,
        resolve: { status: JobStatusResolver, model: ApplyResumeResolver }
      },
      {
        path: 'survey/:elementId',
        component: ApplySurveyComponent,
        resolve: { status: JobStatusResolver, model: ApplySurveyResolver }
      },
      {
        path: 'personal-information',
        component: ApplyPersonalInformationComponent,
        resolve: { status: JobStatusResolver, model: ApplyPersonalInformationResolver }
      },
      {
        path: 'review-and-submit',
        component: ReviewAndSubmitComponent,
        resolve: { status: JobStatusResolver, model: ReviewAndSubmitResolver }
      },
      {
        path: 'employment-history',
        component: ApplyEmploymentHistoryComponent,
        resolve: { status: JobStatusResolver, model: ApplyEmploymentHistoryResolver }
      },
      {
        path: 'education-history',
        component: ApplyEducationHistoryComponent,
        resolve: { status: JobStatusResolver, model: ApplyEducationHistoryResolver }
      },
      {
        path: 'references',
        component: ApplyReferenceComponent,
        resolve: { status: JobStatusResolver, model: ApplyReferenceResolver }
      },
      {
        path: 'voluntary-identification',
        component: ApplyVoluntaryIdentificationComponent,
        resolve: { status: JobStatusResolver, model: ApplyVoluntaryIdentificationResolver }
      }
    ]
  },
  {
    path: 'jobs/:jobId/apply/:applicantId/thank-you',
    component: ApplicantFileLayoutComponent,
    resolve: { status: JobStatusResolver, model: ThemeResolver },
    children: [
      {
        path: '',
        component: ActionThankYouComponent,
        data: { thankYouMessage: 'part-one' }
      }
    ]
  },
  {
    path: 'jobs/:jobId/apply/:applicantId/part-one-already-completed-thank-you',
    component: ApplicantFileLayoutComponent,
    resolve: { status: JobStatusResolver, model: ThemeResolver },
    children: [
      {
        path: '',
        component: ActionThankYouComponent,
        data: { thankYouMessage: 'already-completed' }
      }
    ]
  },
  {
    path: 'jobs/:jobId/apply/:applicantId/finish-later-thank-you',
    component: ApplicantFileLayoutComponent,
    resolve: { status: JobStatusResolver, model: ThemeResolver },
    children: [
      {
        path: '',
        component: ActionThankYouComponent,
        data: { thankYouMessage: 'finish-later' }
      }
    ]
  },
  {
    path: 'jobs/:jobId/apply/:applicantId/submit/:partId',
    component: SubmitIterativeApplicationPartComponent
  },
  {
    path: 'jobs/:jobId/apply/:applicantId/part-2',
    component: IterativeApplicationLandingComponent,
    resolve: { model: IterativeApplicationLandingResolver },
    data: { iterativeApplicationPart: 2 }
  },
  {
    path: 'jobs/:jobId/apply/:applicantId/part-1-completion',
    component: IterativeApplicationLandingComponent,
    resolve: { model: PartOneCompletionResolver },
    data: { iterativeApplicationPart: 1 }
  },
  {
    path: 'jobs/:jobId/applicants/:applicantFileId',
    component: ApplicantFileLayoutComponent,
    resolve: { status: JobStatusResolver, model: ThemeResolver },
    children: [
      {
        path: 'schedule/:interviewId',
        component: ScheduleComponent,
        resolve: { model: ScheduleResolver }
      },
      {
        path: 'schedule/:interviewId/thank-you',
        component: ActionThankYouComponent,
        data: { thankYouMessage: 'interview' }
      },
      {
        path: 'offers/:offerId',
        component: OfferComponent,
        resolve: { model: OfferResolver }
      },
      {
        path: 'offers/:offerId/thank-you',
        component: ActionThankYouComponent,
        data: { thankYouMessage: 'offer' }
      },
      {
        path: 'messages/:messageId',
        component: ApplicantMessageComponent,
        resolve: { model: ApplicantMessageResolver }
      },
      {
        path: 'messages/:messageId/thank-you',
        component: ActionThankYouComponent,
        data: { thankYouMessage: 'message' }
      },
      {
        path: 'reference-collections/:referenceId',
        component: SubmitReferenceComponent,
        resolve: { model: SubmitReferenceResolver }
      },
      {
        path: 'reference-collections/:referenceId/thank-you',
        component: ActionThankYouComponent,
        data: { thankYouMessage: 'reference-collection' }
      }
    ]
  }
];

const routes: Routes = [
  {
    path: 'jobs/:jobId',
    component: DirectJobLinkComponent,
    resolve: { model: DirectJobLinkResolverService }
  },
  {
    path: ':identifier',
    component: ShellComponent,
    resolve: { model: ShellResolver },
    children: [
      {
        path: 'jobs/job-closed',
        component: JobClosedComponent,
        resolve: { model: ThemeResolver }
      },
      {
        path: 'internal/:jobBoardIdentifier',
        data: {
          meta: {
            name: 'robots',
            content: 'noindex'
          }
        },
        children: [
          {
            path: 'jobs/job-closed',
            component: JobClosedComponent,
            resolve: { model: ThemeResolver }
          },
          ...jobRoutes]
      },
      {
        path: ':subBrandIdentifier',
        children: [
          {
            path: 'jobs/job-closed',
            component: JobClosedComponent,
            resolve: { model: ThemeResolver }
          },
          ...jobRoutes]
      },
      ...jobRoutes
    ]
  }];

const routingConfiguration: ExtraOptions = {
  paramsInheritanceStrategy: 'always',
  relativeLinkResolution: 'legacy',
  scrollPositionRestoration: 'enabled'
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routingConfiguration)],
  exports: [RouterModule],
  providers: [ApplyResumeResolver, ApplySurveyResolver, IterativeApplicationLandingResolver, OfferResolver, ThemeResolver, JobResolver,
    SubmitReferenceResolver]
})
export class AppRoutingModule { }
